import * as React from 'react';
import { useState } from 'react';
import { NumericFormat, PatternFormat } from 'react-number-format';
import {
    Button,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from 'reactstrap';

interface UserDetails {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    role: string;
}

interface ManageInformationProps {
    details: UserDetails;
    onSubmit: Function
}

const ManageInformation: React.FC<ManageInformationProps> = ({ details, onSubmit }) => {
    const [user, setUser] = useState<UserDetails>({ ...details });
    const [isEditMode, setIsEditMode] = useState<boolean>(false);
    const [isFirstNameValid, setIsFirstNameValid] = useState<boolean>(true);
    const [isLastNameValid, setIsLastNameValid] = useState<boolean>(true);
    const [isPhoneValid, setIsPhoneValid] = useState<boolean>(true);

    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (validate()) {
            onSubmit(user);
        }
    }

    const validate = () => {
        return (
            validateField("firstName", user.firstName) &&
            validateField("lastName", user.lastName) &&
            validateField("phone", user.phone)
        )
    }

    const validateField = (field: string, value: string) => {

        let isValid = false;

        switch (field) {
            case 'firstName':
                isValid = value && value.trim() !== '' ? true : false;
                setIsFirstNameValid(isValid);
                return isValid;

            case 'lastName':
                isValid = value && value.trim() !== '' ? true : false;
                setIsLastNameValid(isValid);
                return isValid;

            case 'phone':
                let phoneExp = new RegExp(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/);
                isValid = phoneExp.test(value.trim());
                setIsPhoneValid(isValid);
                return isValid;

            default:
                return true;
        }
    }

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        setUser((prevUser: any) => ({...prevUser, [name] : value}));
    };

    const handleEdit = (event: any) => {
        event.preventDefault();
        setIsEditMode(!isEditMode);
    }

    const handleCancel = (event: any) => {
        event.preventDefault();
        var revertedUser = {
            ...user,
            firstName: details.firstName,
            lastName: details.lastName,
            phone: details.phone
        };
        setIsEditMode(!isEditMode);
        setUser({ ...revertedUser });
        setIsFirstNameValid(true);
        setIsLastNameValid(true);
        setIsPhoneValid(true);
    };

    return (
        <div className="col-lg-12 col-md-10 col-sm-12" style={{ padding: "20px" }}>
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col lg="3">
                        <FormGroup>
                            <Label for="firstName" className="fw-bold">FIRST NAME</Label>
                            <p hidden={isEditMode}>{!details.firstName ? <span>{'-'}</span> : details.firstName}</p>
                            <div hidden={!isEditMode}>
                                <Input type="text" name="firstName" id="firstName" placeholder="First Name" invalid={(!isFirstNameValid) ? true : undefined}
                                    onChange={handleChange} value={!user.firstName ? '' : user.firstName} />
                                <small id="firstNameRequired" className="form-text text-muted">Required</small>
                                <div className="invalid-feedback">Please provide a valid First Name.</div>
                            </div>
                        </FormGroup>
                    </Col>
                    <Col lg="3">
                        <FormGroup>
                            <Label for="lastName" className="fw-bold">LAST NAME</Label>
                            <p hidden={isEditMode}>{!details.lastName ? <span>{'-'}</span> : details.lastName}</p>
                            <div hidden={!isEditMode}>
                                <Input type="text" name="lastName" id="lastName" placeholder="Last Name" invalid={(!isLastNameValid) ? true : undefined}
                                    onChange={handleChange} value={!user.lastName ? '' : user.lastName} />
                                <small id="lastNameRequired" className="form-text text-muted">Required</small>
                                <div className="invalid-feedback">Please provide a valid Last Name.</div>
                            </div>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col lg="3">
                        <FormGroup>
                            <Label for="phone" className="fw-bold">PHONE</Label>
                            <p hidden={isEditMode}>{!details.phone ? <span>{'-'}</span> : details.phone}</p>
                            <div hidden={!isEditMode}>
                                <PatternFormat className={'form-control' + ((!isPhoneValid) ? ' is-invalid' : '')} format="(###) ###-####" mask="_" name="phone" id="phone" placeholder="Phone"
                                    onChange={handleChange} value={!user.phone ? '' : user.phone} />
                                <small id="phoneRequired" className="form-text text-muted">Required</small>
                                <div className="invalid-feedback">Please provide a valid Phone.</div>
                            </div>
                        </FormGroup>
                    </Col>
                    <Col lg="3">
                        <FormGroup>
                            <Label className="fw-bold">EMAIL ADDRESS</Label>
                            <p>{!details.email ? <span>{'-'}</span> : details.email}</p>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col lg="3">
                        <FormGroup>
                            <Label className="fw-bold form-label">USER ROLE</Label>
                            <p>{!details.role ? <span>{'-'}</span> : details.role}</p>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col lg="3">
                        {isEditMode === true ?
                            <span>
                                <Button type="submit" color="primary" style={{ marginRight: '10px' }}>Save</Button>
                                <Button onClick={handleCancel}>Cancel</Button>
                            </span>
                            : <span><Button color="primary" onClick={handleEdit} style={{ marginBottom: '20px' }}>Edit</Button></span>}
                    </Col>
                </Row>
            </Form>
        </div>
    );
}
export default ManageInformation;